(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["create-a-product-control"]) return;
  try {
    
  window.addEventListener('load', (event) => {
  document.getElementById('#open-create-a-product').style.visibility = 'visible';
  document.getElementById('#open-create-a-product').addEventListener("click", function(){
    window.scrollBy({top: 200,left: 0,behavior: 'smooth'});
    console.log('new');
	document.querySelector('create-a-case').shadowRoot.querySelector('#create-a-case-application').classList.toggle('deployed');
  document.querySelector('body').classList.toggle('cac-deployed');
    if (document.getElementById('reamazejs-container')){
        document.getElementById('reamazejs-container').style.display="none"
    }
	setTimeout(function() {
		document.querySelector('create-a-case').shadowRoot.querySelector('#create-a-case-application').querySelector('.control-drawer.deployed').scrollIntoView({ behavior: 'smooth', block:'center'});
	}, 800)
    if (document.querySelector('body').style.overflow == "hidden") {
        document.querySelector('body').style.overflow = "scroll";
        document.querySelector('body').style.position = "relative";
    }
    else {
        document.querySelector('body').style.overflow = "hidden";
        document.querySelector('body').style.position = "fixed";
    }
})
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-custom-product"]) return;
  try {
    
  window.addEventListener('load', (event) => {
  console.log('loaded');
  //document.getElementById('#open-create-a-product').innerHTML = document.getElementById('#open-create-a-product').getAttribute('data-text');
  document.getElementById('#open-create-a-product').disabled  = false;
  document.getElementById('#open-create-a-product').addEventListener("click", function(){
  window.scrollBy({top: 200,left: 0,behavior: 'smooth'});
  document.querySelector('create-a-case').shadowRoot.querySelector('#create-a-case-application').classList.toggle('deployed');
  document.querySelector('body').classList.toggle('cac-deployed');
  if (document.getElementById('reamazejs-container')){
  document.getElementById('reamazejs-container').style.display="none"
  }
  setTimeout(function() {
  document.querySelector('create-a-case').shadowRoot.querySelector('#create-a-case-application').querySelector('.control-drawer.deployed').scrollIntoView({ behavior: 'smooth', block:'center'});
  }, 800)
  if (document.querySelector('body').style.overflow == "hidden") {
  document.querySelector('body').style.overflow = "scroll";
  document.querySelector('body').style.position = "relative";
  }
  else {
  document.querySelector('body').style.overflow = "hidden";
  document.querySelector('body').style.position = "fixed";
  }
  })
  });

  } catch(e) { console.error(e); }
})();
})();
